module.exports = __webpack_public_path__ + "img/bzlz.d5f7c5f6.png";